export default "__VITE_ASSET__4216e35a__"